import { render, staticRenderFns } from "./epicofaztec.vue?vue&type=template&id=59bed2fb&scoped=true"
import script from "./epicofaztec.vue?vue&type=script&lang=js"
export * from "./epicofaztec.vue?vue&type=script&lang=js"
import style0 from "./epicofaztec.vue?vue&type=style&index=0&id=59bed2fb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59bed2fb",
  null
  
)

export default component.exports